import {GetterMode} from 'types/basic'

type NonFunction = string | number | boolean | object | null | undefined

export const getter = <T extends NonFunction>(
  valueOrValueFn: T | (() => T),
  mode: GetterMode | undefined,
  isValidOrIsvalidFn: boolean | ((value: T) => boolean),
  errorOrErrorFn: string | Error | (() => Error)
): T => {
  const value = typeof valueOrValueFn === 'function' ? valueOrValueFn() : valueOrValueFn

  if (mode === 'optional') {
    return value
  }

  const isValid = typeof isValidOrIsvalidFn === 'function' ? isValidOrIsvalidFn(value) : isValidOrIsvalidFn

  if (!isValid) {
    throw typeof errorOrErrorFn === 'function'
      ? errorOrErrorFn()
      : typeof errorOrErrorFn === 'string'
      ? new Error(errorOrErrorFn)
      : errorOrErrorFn
  }

  return value
}
